<template>
    <ShiftCalendar></ShiftCalendar>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ShiftCalendar = defineAsyncComponent(() =>
    import("../../components/ShiftCalendar/ShiftCalendar.vue")
);
export default {
    name: "Depart_ShiftCalendar", //The name you are in should not equal the name of the component you are importing.
    components: { ShiftCalendar, AuthLayout },
};
</script>
